<template>
    <li class="relative">
        <button
            @click.prevent="downloadCutSheet(router.page.props.summary.slug)"
            :disabled="isDownloading"
            class="
                bg-gray-120
                dark:bg-gray-700
                border 
                border-keyline-primary
                hover:border-keyline-primary-invert
                flex 
                gap-3 
                group 
                items-center 
                leading-none 
                max-w-full 
                relative 
                rounded 
                text-left 
                w-full 
                p-4
            "
        >
            <LoadingCircle v-if="isDownloading" class="w-5 h-5 p-0.5" />
            <BaseSvg v-else name="Document" aria-hidden="true" class="fill-v2-gray-70 size-5 dark:fill-v2-gray-90" />
            <span class="leading-none text-sm text-v2-gray-20 dark:text-v2-gray-130 dark:group-hover:text-v2-white">Download as PDF</span>
        </button>
    </li>
</template>

<script setup>
import { useCutSheet } from "@/Composables";
import { LoadingCircle } from "@/Components";
import { router } from "@inertiajs/vue3";

const { downloadCutSheet, isDownloading } = useCutSheet();
</script>
